const ArtCardStocks = `
    <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <path d="M50 0v50H0V0h50Z" id="mheczxsc2a"/>
        </defs>
        <g fill="none">
            <path d="M0 0h50v50H0z"/>
            <g fill-rule="nonzero">
                <path fill="#C9DEE4" d="m29.957 18.232-5.047 2.442-4.926-2.495"/>
                <path fill="#9FC8D1" d="M29.866 3.938 34.7 6.37l5.133-2.377-5.133-2.563z"/>
                <path fill="#286072" d="M29.863 3.938v23.175l4.942 2.498V6.403z"/>
                <path fill="#3A768E" d="m34.805 29.611 5.03-2.48V3.991l-5.03 2.412z"/>
                <path fill="#FBEFD2" d="m19.988 18.179 4.835 2.43 5.133-2.377-5.133-2.564z"/>
                <path fill="#E2B559" d="M19.984 18.179v23.174l4.943 2.498V20.643z"/>
                <path fill="#286072" d="M29.863 27.113v10.03l4.983 2.743V29.611z"/>
                <path fill="#3A768E" d="M34.846 29.611v10.275l5.154-2.2-.165-10.555"/>
                <path fill="#F1CA6F" d="m24.927 43.851 5.03-2.48V18.233l-5.03 2.41z"/>
                <path fill="#CAE0E5" d="m10 37.269 4.835 2.43 5.133-2.377-5.133-2.564z"/>
                <path fill="#52A2BA" d="M14.834 39.699v8.872l5.09-2.422v-8.827z"/>
                <path fill="#4B8C9B" d="M14.834 39.699 10 37.269v8.95l4.834 2.352z"/>
            </g>
        </g>
    </svg>
`

export default ArtCardStocks
